/**
 * Dashboard Layout
 *
 * Layout for authenticated dashboard pages.
 * Inspired by 3D SCI Teacher Hub design.
 */

import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export function DashboardLayout() {
  const location = useLocation();
  const isSharedModelView = /^\/dashboard\/shares\/[^/]+\/[^/]+$/.test(location.pathname);
  const isModelSetupView = /^\/dashboard\/setup\/[^/]+$/.test(location.pathname);
  const isImmersiveView = isSharedModelView || isModelSetupView;

  return (
    <div
      className={`${isImmersiveView ? 'h-dvh overflow-hidden' : 'min-h-screen'} bg-slate-50/80 text-foreground dark:bg-background`}
    >
      <main
        className={
          isImmersiveView
            ? 'h-full w-full'
            : 'mx-auto min-h-screen w-full max-w-4xl px-4 py-8 sm:px-6 lg:py-10'
        }
      >
        <Suspense
          fallback={
            <div className="flex min-h-64 items-center justify-center">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}

export default DashboardLayout;
